import { useEffect, useState, useRef } from 'react';

const API_BASE = process.env.REACT_APP_API_BASE_URL || `${process.env.FRONTEND_URL}/api`;


export default function TestimonialsCarousel() {
  const [testimonials, setTestimonials] = useState([]);
  const scrollRef = useRef(null);

  useEffect(() => {
    fetch(`${API_BASE}/testimonials`)
      .then((r) => r.json())
      .then((json) => setTestimonials(json.success ? json.data : []));
  }, []);

  const scroll = (dir) => {
    scrollRef.current?.scrollBy({ left: dir === 'left' ? -420 : 420, behavior: 'smooth' });
  };

  if (testimonials.length === 0) return null;

  return (
    <section className="py-24 bg-white overflow-hidden">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex justify-between items-center mb-16">
          <h2 className="text-3xl font-bold text-[#00255a]">Student Success Stories</h2>
          <div className="flex gap-4">
            <button onClick={() => scroll('left')} className="w-12 h-12 rounded-full border-2 border-[#e2e8f0] flex items-center justify-center text-[#00255a] hover:bg-[#00255a] hover:text-white transition-all">
              <span className="material-symbols-outlined">chevron_left</span>
            </button>
            <button onClick={() => scroll('right')} className="w-12 h-12 rounded-full border-2 border-[#e2e8f0] flex items-center justify-center text-[#00255a] hover:bg-[#00255a] hover:text-white transition-all">
              <span className="material-symbols-outlined">chevron_right</span>
            </button>
          </div>
        </div>

        <div ref={scrollRef} className="flex gap-6 overflow-x-auto pb-8 snap-x scroll-smooth">
          {testimonials.map((t) => (
            <div key={t.id} className="min-w-[320px] md:min-w-[400px] snap-start bg-[#f2f4f6] p-8 rounded-2xl border border-[#e2e8f0]">
              <div className="flex gap-1 text-[#862026] mb-6">
                {Array.from({ length: t.rating || 5 }).map((_, i) => (
                  <span key={i} className="material-symbols-outlined">star</span>
                ))}
              </div>
              <p className="text-[#44474f] italic mb-8">&quot;{t.quoteText}&quot;</p>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full overflow-hidden bg-[#e2e8f0]">
                  {t.mediaUrl && <img className="w-full h-full object-cover" src={t.mediaUrl || "images/countries/poland.jpg"} alt={t.name} />}
                </div>
                <div>
                  <p className="font-bold text-[#00255a]">{t.name}</p>
                  {t.country && <p className="text-[#64748b] text-sm">{t.country}</p>}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}